module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-255.81548789.jpg";